import React, { useContext } from 'react';
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Button, Modal, Row, Col, Card } from 'react-bootstrap';
import exxonLogo from '../../../images/cmn-exxonmobil-logo.gif';
import jemmacLogo from '../../../images/jemmac_logo.png';
import { useListPrivileges, useUserAreas } from '../../../hooks/usePrivileges';
import { SiteContext } from '../../Contexts/SiteContext';


function AboutDlg({ isOpen, toggleModal, userName, version, copyright }) {

    const { sitesAssignedToUser } = useContext(SiteContext);
    const { areas } = useUserAreas();
    const { privileges } = useListPrivileges();

    return (
        <Modal dialogAs={DraggableModalDialog} show={isOpen} onHide={toggleModal} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    About
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>OMDGo is the property of ExxonMobil Corporation. You are responsible for reading the disclaimer below :</p>
                <Card>
                    <Card.Body>
                        <p>Access is restricted to those specifically authorized by ExxonMobil Corporation and its affiliates ("Company"), and is to be used solely for Company-authorized purposes. This system has security facilities to prevent and record unauthorized access attempts.</p>
                        <p>Your authorization to access this system is contingent upon your acknowledgement that ALL FILES, DATA, ELECTRONIC MESSAGES, PROGRAMS, AND OTHER STORED ITEMS PLACED ON THIS SYSTEM BELONG TO THE COMPANY. The Company is likely to examine activity and stored items to the fullest extent permitted by law.</p>
                        <p>Your authorization to access this system is also contingent upon your acceptance of the legal obligation not to use the system in a way that would violate any law or that would be inconsistent with Company policies or standards including those on Ethics, Harassment, Conflict of Interest or Systems Security.</p>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={3}>
                                <p>Version:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{version}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>User:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{userName}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>Privileges:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{privileges && privileges.join(', ')}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>Sites:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{sitesAssignedToUser && sitesAssignedToUser.map(s => s.name).join(', ')}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>Areas:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{areas && areas.join(', ')}</p>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <p className="text-center">Developed by Jemmac Software Ltd under contract to ExxonMobil</p>
                <Row>
                    <Col>
                        <img src={exxonLogo} alt="ExxonMobil logo" className="float-end me-3" />
                    </Col>
                    <Col>
                        <img src={jemmacLogo} alt="Jemmac logo" />
                    </Col>
                </Row>
                <p className="text-center">{copyright}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button color="primary" onClick={toggleModal}>Ok</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AboutDlg;